import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import RefillForm from "pages/refill/RefillForm";
import React from "react";

const RefillDialog = ({ open, handleClose, tray_id, partition }) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={() => {
        handleClose();
      }}
      heading="Refill product"
    >
      <Box sx={{ overflow: "hidden", padding: 2 }}>
        <RefillForm tray_id={tray_id} partition={partition} fullGrid={true} handleClose={handleClose} />
      </Box>
    </CustomDialog>
  );
};

export default RefillDialog;
